import * as Yup from 'yup';

// Regex for mobile number formats
// For mobile No.
export const mobileNumberRegex = /^(\+91[-\s]?|0?91[-\s]?|0)?[6-9]\d{2}[-\s]?\d{4}[-\s]?\d{3}$/;

// For cell No.
export const cellNumberRegex = /^(\+91[-\s]?|0?91[-\s]?|0)?[6-9]\d{2}[-\s]?\d{4}[-\s]?\d{3}$/;

// For guardian contact No.
export const guardianContactNumberRegex =
	/^(\+91[-\s]?|0?91[-\s]?|0)?[6-9]\d{2}[-\s]?\d{4}[-\s]?\d{3}$/;

// For Contact No.
export const contactNumberSchema = Yup.string()
	.required('Contact number is required')
	.test('is-valid-mobile', 'Invalid mobile number format', (value) => {
		if (!value) return false;

		// Remove spaces and hyphens for validation
		const cleaned = value.replace(/[\s-]/g, '');

		// Must be exactly 10 digits (or valid +91/091/0 prefix)
		if (!/^(?:\+91|0?91|0)?[6-9]\d{9}$/.test(cleaned)) {
			return false;
		}

		// Also match allowed display formats
		return mobileNumberRegex.test(value) || true;
	});

// For cell No.
export const cellNumberSchema = Yup.string()
	.required('Cell number is required')
	.test('is-valid-cell', 'Invalid cell number format', (value) => {
		if (!value) return false;

		// Remove spaces and hyphens for validation
		const cleaned = value.replace(/[\s-]/g, '');

		// Must be exactly 10 digits (or valid +91/091/0 prefix)
		if (!/^(?:\+91|0?91|0)?[6-9]\d{9}$/.test(cleaned)) {
			return false;
		}

		// Also match allowed display formats
		return cellNumberRegex.test(value) || true;
	});

// For guardian contact No.
export const guardianContactNumberSchema = Yup.string()
	.required('Guardian contact number is required')
	.test('is-valid-guardian-contact-no', 'Invalid guardian contact number format', (value) => {
		if (!value) return false;

		// Remove spaces and hyphens for validation
		const cleaned = value.replace(/[\s-]/g, '');

		// Must be exactly 10 digits (or valid +91/091/0 prefix)
		if (!/^(?:\+91|0?91|0)?[6-9]\d{9}$/.test(cleaned)) {
			return false;
		}

		// Also match allowed display formats
		return guardianContactNumberRegex.test(value) || true;
	});

// Common input change handler
// For Contact No.
export const handleContactChange = (
	e: React.ChangeEvent<HTMLInputElement>,
	setFieldValue: (field: string, value: any) => void,
) => {
	let value = e.target.value;

	// Remove all characters except digits, spaces, hyphens, and plus
	value = value.replace(/[^0-9+\s-]/g, '');
	const cleaned = value.replace(/[\s-]/g, '');
	const digitCount = cleaned.length;

	// Prevent typing more than allowed formats
	if (/^\+91/.test(value) && value.length > 14) return;
	if (/^0?91/.test(value) && value.length > 15) return;
	if (/^([6-9][0-9]{2}[-\s]?[0-9]{4}[-\s]?[0-9]{3})$/.test(value) && value.length > 12) return;
	if (/^[6-9]/.test(cleaned) && digitCount > 10) return;
	if (/^[6-9]/.test(value) && value.length > 12) return;

	// NEW: Prevent setting value if less than 10 digits
	if (digitCount < 10) {
		setFieldValue('validationContact', value); // still show partial input
		return;
	}

	setFieldValue('validationContact', value);
};

// For cell No.
export const handleCellChange = (
	e: React.ChangeEvent<HTMLInputElement>,
	setFieldValue: (field: string, value: any) => void,
) => {
	let value = e.target.value;

	// Remove all characters except digits, spaces, hyphens, and plus
	value = value.replace(/[^0-9+\s-]/g, '');
	const cleaned = value.replace(/[\s-]/g, '');
	const digitCount = cleaned.length;

	// Prevent typing more than allowed formats
	if (/^\+91/.test(value) && value.length > 14) return;
	if (/^0?91/.test(value) && value.length > 15) return;
	if (/^([6-9][0-9]{2}[-\s]?[0-9]{4}[-\s]?[0-9]{3})$/.test(value) && value.length > 12) return;
	if (/^[6-9]/.test(cleaned) && digitCount > 10) return;
	if (/^[6-9]/.test(value) && value.length > 12) return;

	// NEW: Prevent setting value if less than 10 digits
	if (digitCount < 10) {
		setFieldValue('validationCell', value); // still show partial input
		return;
	}

	setFieldValue('validationCell', value);
};

// For guardian contact No.
export const handleGuardianContactChange = (
	e: React.ChangeEvent<HTMLInputElement>,
	setFieldValue: (field: string, value: any) => void,
) => {
	let value = e.target.value;

	// Remove all characters except digits, spaces, hyphens, and plus
	value = value.replace(/[^0-9+\s-]/g, '');
	const cleaned = value.replace(/[\s-]/g, '');
	const digitCount = cleaned.length;

	// Prevent typing more than allowed formats
	if (/^\+91/.test(value) && value.length > 14) return;
	if (/^0?91/.test(value) && value.length > 15) return;
	if (/^([6-9][0-9]{2}[-\s]?[0-9]{4}[-\s]?[0-9]{3})$/.test(value) && value.length > 12) return;
	if (/^[6-9]/.test(cleaned) && digitCount > 10) return;
	if (/^[6-9]/.test(value) && value.length > 12) return;

	// NEW: Prevent setting value if less than 10 digits
	if (digitCount < 10) {
		setFieldValue('validationGuardianContactNo', value); // still show partial input
		return;
	}

	setFieldValue('validationGuardianContactNo', value);
};

// Inquiry (CRM) - For Customer Mobile No.
export const handleMobileChange = (
	e: React.ChangeEvent<HTMLInputElement>,
	setFieldValue: (field: string, value: any) => void,
) => {
	let value = e.target.value;

	// Remove all characters except digits, spaces, hyphens, and plus
	value = value.replace(/[^0-9+\s-]/g, '');
	const cleaned = value.replace(/[\s-]/g, '');
	const digitCount = cleaned.length;

	// Prevent typing more than allowed formats
	if (/^\+91/.test(value) && value.length > 14) return;
	if (/^0?91/.test(value) && value.length > 15) return;
	if (/^([6-9][0-9]{2}[-\s]?[0-9]{4}[-\s]?[0-9]{3})$/.test(value) && value.length > 12) return;
	if (/^[6-9]/.test(cleaned) && digitCount > 10) return;
	if (/^[6-9]/.test(value) && value.length > 12) return;

	// NEW: Prevent setting value if less than 10 digits
	if (digitCount < 10) {
		setFieldValue('validationCustomerMobile', value); // still show partial input
		return;
	}

	setFieldValue('validationCustomerMobile', value);
};